import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useDrawerPersistence = create()(persist(set => ({
  open: true,
  setOpen: open => set({
    open
  })
}), {
  name: 'academy-ai-assistant-drawer'
}));